import scrollLock from './scrollLock';

const header = () => {
  const pageHeader = document.querySelector('[data-page-header]');

  window.onscroll = function() {
    const top = window.pageYOffset;
    if (top >= 1 || scrollLock.islocked()) {
      pageHeader.classList.add('c-header--fixed');
    } else {
      pageHeader.classList.remove('c-header--fixed');
    }
  };
};

export default header;



// WEBPACK FOOTER //
// ./public/wp-content/themes/druckhaus/src/scripts/modules/header.js